import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtils';
import { storeDefaultStates } from '../../hooks/useStoreStateHook';

const storeStateActions = mapDefaultValuesToActions(storeDefaultStates);

export default reduxReducerHelper(storeStateActions, storeDefaultStates, false);
